import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const GoogleMapsWidgetV2: WidgetRegistryEntry = {
  name: "GoogleMapsV2",
  configuration: () => import("./configuration").then((m) => m.GoogleMapsV2WidgetConfiguration),
  component: () => import("./google-maps-v2-widget.component").then((m) => m.GoogleMapsV2WidgetComponent)
};
